import { z } from 'zod';
import { zExercise, zExerciseMetric, zSet, zEditType, zSetMetricEdit, } from './base';
import { zExercise as _zExercise } from '../../core';
export const CreateWorkout = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
});
export const AddSection = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    name: z.string(),
    sortOrder: z.number(),
    exercises: z.array(zExercise),
});
export const EditSection = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    addedOnThisLayer: z.boolean(),
    editType: zEditType,
    workoutSectionId: z.uuid(),
    name: z.string().optional(),
    sortOrder: z.number().optional(),
});
export const RemoveSection = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    addedOnThisLayer: z.boolean(),
});
export const RestoreSection = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    exercises: z.array(zExercise),
});
export const AddExercise = z
    .object({
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
})
    .merge(zExercise);
export const EditExercise = z
    .object({
    id: z.uuid(),
    workoutId: z.uuid(),
    addedOnThisLayer: z.boolean(),
    editType: zEditType,
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
})
    .merge(_zExercise.partial());
export const RemoveExercise = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    addedOnThisLayer: z.boolean(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
});
export const RestoreExercise = z
    .object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
})
    .merge(zExercise.pick({
    sets: true,
    metrics: true,
}));
export const AddExerciseMetric = z
    .object({
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
    workoutExerciseMetricId: z.uuid(),
    benchmarkGridId: z.uuid().optional(),
})
    .merge(zExerciseMetric);
export const RemoveExerciseMetric = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    addedOnThisLayer: z.boolean(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
    workoutExerciseMetricId: z.uuid(),
});
export const RestoreExerciseMetric = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
    workoutExerciseMetricId: z.uuid(),
});
export const AddSet = z
    .object({
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
})
    .merge(zSet);
export const EditSetMetrics = z.object({
    workoutId: z.uuid(),
    metrics: z.array(z
        .object({
        id: z.uuid(),
        addedOnThisLayer: z.boolean(),
        editType: zEditType,
        workoutSectionId: z.uuid(),
        workoutExerciseId: z.uuid(),
        workoutSetId: z.uuid(),
        workoutSetMetricId: z.uuid(),
    })
        .merge(zSetMetricEdit)),
});
export const RemoveSet = z.object({
    id: z.uuid(),
    workoutId: z.uuid(),
    addedOnThisLayer: z.boolean(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
    workoutSetId: z.uuid(),
});
export const RestoreSet = z
    .object({
    id: z.uuid(),
    workoutId: z.uuid(),
    workoutSectionId: z.uuid(),
    workoutExerciseId: z.uuid(),
    workoutSetId: z.uuid(),
})
    .merge(zSet.pick({
    metrics: true,
}));
//# sourceMappingURL=command-inputs.js.map